module.exports = __webpack_public_path__ + "img/tickets.78fbc51c.svg";